export const trimNumber = ( number, decimalPlaces ) => {
	if ( !number )
		return 0;

	const factor = 10 ** decimalPlaces;

	return Math.round ( number * factor ) / factor;
};